import React from 'react';

import styled from 'styled-components';
import CloseIcon from "../../../assets/images/icon/CloseIcon";


const VideoPlayerComponent = (props) => {
    function calculateHeightFor16x9(width) {
        const aspectRatio = 9 / 16; // 세로 비율 / 가로 비율
        const height = width * aspectRatio;
        return height;
    }

return(
  <Container style={{width:props?.width, height:calculateHeightFor16x9(props?.width)}}>
    {props.children}
      {/*<OverlayItem className={props.filter ? "on" : "off"}></OverlayItem>*/}
      {/*<Close onClick={()=>{props?.onClickClose()}}>*/}
      {/*    <CloseIcon/>*/}
      {/*</Close>*/}
  </Container>
)

}
export { VideoPlayerComponent };

const Container = styled.div`
    
    position: fixed;
    z-index: 999999;
    background: #33333360;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    width: 90%!important;
    max-width: 800px!important;

`;
const Close = styled.div`
   position: absolute;
    right: 30px;
    top: -20px;
    cursor: pointer;
    svg{
        width: 30px;
        height: 30px;
        opacity: 0.8;
    }
 
    transform: translate(110%, -80%);
`
const OverlayItem = styled.div`
    &.on{
        backdrop-filter: blur(3px);
    }
    z-index: -1;
    background: #33333360;
    position: absolute;
    width: 300vw;
    height: 500vh;
`;